import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-bar-main',
  templateUrl: './nav-bar-main.component.html',
  styleUrls: ['./nav-bar-main.component.css']
})
export class NavBarMainComponent implements OnInit {
  public isCollapsed = false;
  constructor() { }

  ngOnInit() {
  }

}
